(function() {
  'use strict';

  console.log('🎯 Cart Discount Handler: Script loaded');

  // Configuration - Set your discount code here
  const DISCOUNT_CODE = 'b2b-discount-test';
  const B2B_TAG = 'b2b-customer'; // Must match the tag used in registration

  /**
   * Check if customer is a B2B customer
   * @returns {boolean}
   */
  function isB2BCustomer() {
    // Check if customer is logged in and has B2B tag
    if (window.Shopify && window.Shopify.customer) {
      const customer = window.Shopify.customer;
      const hasB2BTag = customer.tags && customer.tags.includes(B2B_TAG);
      
      console.log('👤 Customer check:', {
        isLoggedIn: !!customer,
        customerId: customer.id,
        tags: customer.tags,
        hasB2BTag: hasB2BTag
      });
      
      return hasB2BTag;
    }
    
    console.log('👤 No customer logged in or customer object not available');
    return false;
  }

  /**
   * Adds discount code to checkout URL
   * @param {HTMLFormElement} form - The cart form element
   */
  function addDiscountToCheckoutUrl(form) {
    console.log('🔧 addDiscountToCheckoutUrl called');
    
    // Check if customer is B2B
    if (!isB2BCustomer()) {
      console.log('⚠️ Customer is not a B2B customer - skipping discount');
      return;
    }
    
    console.log('✅ B2B customer detected - proceeding with discount');
    
    if (!form) {
      console.error('❌ No form provided to addDiscountToCheckoutUrl');
      return;
    }

    const currentAction = form.getAttribute('action') || '';
    console.log('📋 Current form action:', currentAction);
    
    // Check if discount parameter already exists
    if (currentAction.includes('discount=')) {
      console.log('⚠️ Discount already present in checkout URL');
      return;
    }

    // Determine the separator (? or &)
    const separator = currentAction.includes('?') ? '&' : '?';
    console.log('🔗 Using separator:', separator);
    
    // Append discount code
    const newAction = currentAction + separator + 'discount=' + encodeURIComponent(DISCOUNT_CODE);
    
    form.setAttribute('action', newAction);
    
    console.log('✅ Updated checkout URL with B2B discount:', DISCOUNT_CODE);
    console.log('🎉 New action:', newAction);
  }

  /**
   * Initialize the discount handler
   */
  function init() {
    console.log('🚀 Initializing cart discount handler...');
    console.log('📄 Document ready state:', document.readyState);
    
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      console.log('⏳ Waiting for DOMContentLoaded...');
      document.addEventListener('DOMContentLoaded', attachListeners);
    } else {
      console.log('✅ DOM already loaded, attaching listeners now');
      attachListeners();
    }
  }

  /**
   * Attach event listeners to checkout buttons
   */
  function attachListeners() {
    console.log('🔍 Looking for cart form...');
    const cartForm = document.querySelector('form.cart-page');
    
    if (!cartForm) {
      console.error('❌ Cart form not found! Selector: form.cart-page');
      console.log('📋 Available forms:', document.querySelectorAll('form'));
      return;
    }

    console.log('✅ Cart form found:', cartForm);
    console.log('📋 Form current action:', cartForm.getAttribute('action'));

    // Find the checkout button
    console.log('🔍 Looking for checkout button...');
    const checkoutButton = cartForm.querySelector('button[name="checkout"]');
    
    if (!checkoutButton) {
      console.error('❌ Checkout button not found! Selector: button[name="checkout"]');
      console.log('📋 Available buttons in form:', cartForm.querySelectorAll('button'));
      return;
    }

    console.log('✅ Checkout button found:', checkoutButton);

    // Intercept form submission to add discount at the last moment
    cartForm.addEventListener('submit', function(event) {
      console.log('🛑 FORM SUBMIT EVENT FIRED!');
      event.preventDefault(); // Stop the submission temporarily
      
      console.log('⏸️ Form submit intercepted, adding discount...');
      console.log('📋 Current action before discount:', cartForm.getAttribute('action'));
      
      // Add the discount code
      addDiscountToCheckoutUrl(cartForm);
      
      // Allow the form to submit after a brief delay
      setTimeout(() => {
        console.log('⏩ Submitting form with discount...');
        cartForm.submit();
      }, 200);
    });

    console.log('🎉 Cart discount handler initialized successfully!');
    console.log('👂 Listening for form submission events...');
  }

  // Initialize
  init();
})();